import { render, staticRenderFns } from "./SignatureViewItem.view.vue?vue&type=template&id=45f0479a&"
import script from "./SignatureViewItem.view.vue?vue&type=script&lang=js&"
export * from "./SignatureViewItem.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45f0479a')) {
      api.createRecord('45f0479a', component.options)
    } else {
      api.reload('45f0479a', component.options)
    }
    module.hot.accept("./SignatureViewItem.view.vue?vue&type=template&id=45f0479a&", function () {
      api.rerender('45f0479a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/overlays/popups/signature/SignatureViewItem.view.vue"
export default component.exports